// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/CourierModal/pages/Scanners/styles/ScannerManual.module.css */

.ScannerManual_manualContainer__ynQFs {
  display: flex;
  flex-direction: column;
  height: 100%;          /* заполняет родительский .scannerWrapper */
  box-sizing: border-box;
  padding: 0.5rem;
  background: #fff;
}

.ScannerManual_filters__L9IpK {
  flex: 0 0 auto;
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.ScannerManual_input__GBxd5 {
  flex: 1 1;
  padding: 0.5rem;
  font-size: 0.9rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.ScannerManual_listContainer__-LBzs {
  flex: 1 1 auto;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.5rem;
  padding: 0.5rem;        /* чтобы тени и отступы работали */
  box-sizing: border-box;
}

.ScannerManual_markItem__OeC3M {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.4rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.ScannerManual_serialText__unfXV {
  font-size: 0.75rem;
  font-weight: bold;
  margin-bottom: 0.25rem;
}

.ScannerManual_nameText__uZine {
  font-size: 0.75rem;
  text-align: center;
  margin: 0.25rem 0;
}

.ScannerManual_dateText__tfEm4 {
  font-size: 0.7rem;
  color: #555;
}

.ScannerManual_markItem__OeC3M.ScannerManual_selected__k049\\+ {
  box-shadow: 0 0 0 2px #007bff;
}

.ScannerManual_checkOverlay__uyCE7 {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  background: rgba(0, 123, 255, 0.8);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
}

.ScannerManual_submitBtn__rn8TN {
  flex: 0 0 auto;
  margin-top: 0.5rem;
  padding: 0.6rem;
  font-size: 1rem;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.ScannerManual_submitBtn__rn8TN:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ScannerManual_empty__qvxG- {
  grid-column: 1 / -1;
  text-align: center;
  color: #777;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/pages/Scanners/styles/ScannerManual.module.css"],"names":[],"mappings":"AAAA,0FAA0F;;AAE1F;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,WAAW,2CAA2C;EAClE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,eAAe,SAAS,kCAAkC;EAC1D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["/* src/modules/Courier/pages/CourierModal/pages/Scanners/styles/ScannerManual.module.css */\r\n\r\n.manualContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;          /* заполняет родительский .scannerWrapper */\r\n  box-sizing: border-box;\r\n  padding: 0.5rem;\r\n  background: #fff;\r\n}\r\n\r\n.filters {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.input {\r\n  flex: 1;\r\n  padding: 0.5rem;\r\n  font-size: 0.9rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.listContainer {\r\n  flex: 1 1 auto;\r\n  overflow-y: auto;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\r\n  gap: 0.5rem;\r\n  padding: 0.5rem;        /* чтобы тени и отступы работали */\r\n  box-sizing: border-box;\r\n}\r\n\r\n.markItem {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0.4rem;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.serialText {\r\n  font-size: 0.75rem;\r\n  font-weight: bold;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.nameText {\r\n  font-size: 0.75rem;\r\n  text-align: center;\r\n  margin: 0.25rem 0;\r\n}\r\n\r\n.dateText {\r\n  font-size: 0.7rem;\r\n  color: #555;\r\n}\r\n\r\n.markItem.selected {\r\n  box-shadow: 0 0 0 2px #007bff;\r\n}\r\n\r\n.checkOverlay {\r\n  position: absolute;\r\n  top: 4px;\r\n  right: 4px;\r\n  width: 16px;\r\n  height: 16px;\r\n  background: rgba(0, 123, 255, 0.8);\r\n  color: #fff;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.submitBtn {\r\n  flex: 0 0 auto;\r\n  margin-top: 0.5rem;\r\n  padding: 0.6rem;\r\n  font-size: 1rem;\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.submitBtn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.empty {\r\n  grid-column: 1 / -1;\r\n  text-align: center;\r\n  color: #777;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manualContainer": `ScannerManual_manualContainer__ynQFs`,
	"filters": `ScannerManual_filters__L9IpK`,
	"input": `ScannerManual_input__GBxd5`,
	"listContainer": `ScannerManual_listContainer__-LBzs`,
	"markItem": `ScannerManual_markItem__OeC3M`,
	"serialText": `ScannerManual_serialText__unfXV`,
	"nameText": `ScannerManual_nameText__uZine`,
	"dateText": `ScannerManual_dateText__tfEm4`,
	"selected": `ScannerManual_selected__k049+`,
	"checkOverlay": `ScannerManual_checkOverlay__uyCE7`,
	"submitBtn": `ScannerManual_submitBtn__rn8TN`,
	"empty": `ScannerManual_empty__qvxG-`
};
export default ___CSS_LOADER_EXPORT___;
